<template>
    <div class="container-fluid">
        <Breadcrumb title="SMTP Campaign Statistics" v-bind:button-show=false></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="loading">
                <Preloader v-bind:class="{preloader: loading}"></Preloader>
            </div>
            <div class="col-12" v-else>
                <div class="card">
                    <div class="card-body">
                        <div class="progress" style="height:36px;">
                            <div class="progress-bar bg-info"
                                 v-bind:style="{width: progress +'%'}" style="min-width:5%;" role="progressbar"
                                 aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                                <span style="font-size:20px;">{{progress}} %</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 float-left pl-0 pr-xl-3 pr-0">
                    <div class="card">
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-sm">
                                    <tr>
                                        <th>ID</th>
                                        <td>{{id}}</td>
                                    </tr>
                                    <tr>
                                        <th>Name</th>
                                        <td>{{overallStats.name}}</td>
                                    </tr>
                                    <tr>
                                        <th>Email List</th>
                                        <td>{{overallStats.emailList}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{overallStats.start !== '' ? 'Start' : (overallStats.scheduledStart !== '' ? 'Scheduled Start' : 'Start')}}</th>
                                        <td>{{overallStats.start !== '' ? overallStats.start : (overallStats.scheduledStart !== '' ? overallStats.scheduledStart : '')}}</td>
                                    </tr>
                                    <tr>
                                        <th>{{overallStats.end !== '' ? 'End' : (overallStats.scheduledStop !== '' ? 'Scheduled Stop' : 'End')}}</th>
                                        <td>{{overallStats.end !== '' ? overallStats.end : (overallStats.scheduledStop !== '' ? overallStats.scheduledStop : '')}}</td>
                                    </tr>
                                    <tr>
                                        <th>Total</th>
                                        <td>{{overallStats.total}}</td>
                                    </tr>
                                    <tr>
                                        <th>Delivered</th>
                                        <td>{{overallStats.delivered}}</td>
                                    </tr>
                                    <tr>
                                        <th>Bounced</th>
                                        <td>{{overallStats.bounced}}</td>
                                    </tr>
                                    <tr>
                                        <th>Open</th>
                                        <td>{{overallStats.open}}</td>
                                    </tr>
                                    <tr>
                                        <th>Click</th>
                                        <td>{{overallStats.click}}</td>
                                    </tr>
                                    <tr>
                                        <th>Unsubscribed</th>
                                        <td>{{overallStats.unsubscribed}}</td>
                                    </tr>
                                    <tr>
                                        <th>Conversion</th>
                                        <td>{{overallStats.conversion}}</td>
                                    </tr>
                                    <tr>
                                        <th>Profit</th>
                                        <td>{{overallStats.profit}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-8 float-left pr-0 pl-0">
                    <div class="card">
                        <div class="card-body pt-2">
                            <button type="button" class="close mb-1" aria-label="Close">
                                <i class="fas fa-sync pb-2" aria-hidden="true" @click="getPerProvidersStats(id)" style="font-size: 12px;"></i>
                            </button>
                            <div class="table-responsive">
                                <table class="table table-sm">
                                    <thead>
                                    <tr>
                                        <th>Service</th>
                                        <th>Total</th>
                                        <th>Processed</th>
                                        <th>Delivered</th>
                                        <th>Bounced</th>
                                        <th>Open</th>
                                        <th>Click</th>
                                        <th>Unsub.</th>
                                        <th>Conv.</th>
                                        <th>Profit</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(provider, index) in perProvidersStats" :key="index">
                                        <td class="provider-name">
                                            <span role='button' @click="getPerDomainsStats(id, provider.id, provider.name)">
                                                {{provider.name}}
                                            </span>
                                        </td>
                                        <td>
                                            {{provider.total}} ({{(provider.total * 100 / overallStats.total).toFixed(1)}}%)
                                        </td>
                                        <td>
                                            {{provider.delivered + provider.bounced}} ({{((provider.delivered + provider.bounced) * 100 / provider.total).toFixed(1)}}%)
                                        </td>
                                        <td>{{provider.delivered}}</td>
                                        <td>{{provider.bounced}}</td>
                                        <td>{{provider.open}}</td>
                                        <td>{{provider.click}}</td>
                                        <td>{{provider.unsubscribed}}</td>
                                        <td>{{provider.conversion}}</td>
                                        <td>{{provider.profit}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 float-left pr-0 pl-0" v-if="selectedProvider">
                    <div class="card">
                        <div class="card-body pt-3">
                            <button type="button" class="close mb-1" aria-label="Close">
                                <span aria-hidden="true" @click="selectedProvider=null">&times;</span>
                            </button>
                            <div class="h5"></div>
                            <h4 class="text-themecolor">Top 20 domains in {{selectedProvider}} mail service:</h4>
                            <div class="table-responsive">
                                <table class="table table-sm">
                                    <thead>
                                    <tr>
                                        <th>Domain</th>
                                        <th>Total</th>
                                        <th>Processed</th>
                                        <th>Delivered</th>
                                        <th>Bounced</th>
                                        <th>Open</th>
                                        <th>Click</th>
                                        <th>Unsub.</th>
                                        <th>Conv.</th>
                                        <th>Profit</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(domain, index) in perDomainsStats" :key="index">
                                        <td>{{domain.domain}}</td>
                                        <td>{{domain.total}}</td>
                                        <td>{{domain.processed}}</td>
                                        <td>{{domain.delivered}}</td>
                                        <td>{{domain.bounced}}</td>
                                        <td>{{domain.views}}</td>
                                        <td>{{domain.clicks}}</td>
                                        <td>{{domain.unsubscribers}}</td>
                                        <td>{{domain.conversions}}</td>
                                        <td>{{domain.profit}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                                <div class="spinner-border text-info m-2" role="status" v-if="!perDomainsStats">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CampaignService from '../services/SmtpCampaignService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import config from '../config';
    import {mapGetters} from 'vuex';
    import {CampaignType} from '../constants';

    export default {
        name: 'SmtpCampaignStatistics',
        components: {
            Preloader, Breadcrumb
        },
        props: ['id'],
        data() {
            return {
                overallStats: {
                    name: '',
                    emailList: '',
                    scheduledStart: '',
                    start: '',
                    scheduledStop: '',
                    end: '',
                    total: 0,
                    delivered: 0,
                    bounced: 0,
                    unsubscribed: 0,
                    open: 0,
                    click: 0,
                    conversion: 0,
                    profit: 0
                },
                perProvidersStats: null,
                perDomainsStats: null,
                selectedProvider: null,
                loading: false,
            }
        },
        mounted() {
            this.loading = true;
            this.getOverallStats(this.id);
            this.getPerProvidersStats(this.id);

            this.updateCampaignStatistics();
        },
        computed: {
            progress: function () {
                if (0 === this.overallStats.total) {
                    return '0'
                }
                let $processed = this.overallStats.delivered + this.overallStats.bounced;
                let $inPercent = (100 * $processed / this.overallStats.total) || 0;
                return $inPercent.toFixed(1);
            },
            ...mapGetters({mercureListen: 'listen'})
        },
        methods: {
            getOverallStats: function (id) {
                CampaignService.getCampaignStatistics(id, 'overall').then(response => {
                    this.overallStats = response.data.overallStats;
                    this.loading = false;
                });
            },
            getPerProvidersStats: function (id) {
                this.perProvidersStats = null;
                CampaignService.getCampaignStatistics(id, 'perProviders').then(response => {
                    this.perProvidersStats = response.data.perProvidersStats;
                });
            },
            getPerDomainsStats: function (id, providerId, providerName) {
                this.perDomainsStats = null;
                this.selectedProvider = providerName;
                CampaignService.getCampaignStatistics(id, 'perDomains', providerId).then(response => {
                    this.perDomainsStats = response.data.perDomainsStats;
                });
            },
            updateCampaignStatistics() {
                if (!this.mercureListen.hasOwnProperty('campaignStatistics')) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.campaignStatisticsSent);
                    url.searchParams.append('topic', config.campaignStatisticsBounces);
                    url.searchParams.append('topic', config.campaignStatisticsOpens);
                    url.searchParams.append('topic', config.campaignStatisticsClicks);
                    url.searchParams.append('topic', config.campaignStatisticsUnsubscribers);
                    url.searchParams.append('topic', config.campaignStatisticsProfit);
                    let eventSource = new EventSource(url);
                    this.$store.commit('setListening', {['campaignStatistics']: eventSource});
                }
                this.mercureListen['campaignStatistics'].onmessage = event => {
                    let data = JSON.parse(event.data);
                    if (data.campaignType === CampaignType.SMTP && data.campaignId === parseInt(this.id, 10)) {
                        if (data.sent !== undefined) {
                            this.overallStats.delivered = data.sent;
                        }

                        if (data.totalToSend !== undefined) {
                            this.overallStats.total = data.totalToSend;
                        }

                        if (data.opens !== undefined) {
                            this.overallStats.open = data.opens;
                        }

                        if (data.clicks !== undefined) {
                            this.overallStats.click = data.clicks;
                        }

                        if (data.unsubscribers !== undefined) {
                            this.overallStats.unsubscribed = data.unsubscribers;
                        }

                        if (data.profit !== undefined) {
                            this.overallStats.profit = data.profit;
                        }

                        if (data.bounces !== undefined) {
                            this.overallStats.bounced = data.bounces;
                        }
                    }
                }
            }
        }
    }
</script>

<style scoped>
    td {
        font-family: arial, serif;
    }

    .provider-name {
        color: #146da6;
        font-weight: 400;
    }
</style>